// @flow
import $ from 'jquery';
import JQueryView from '../../common/JQueryView';
import { on } from '../../../../admin/views/common/JQueryView';

export default class ChangeSelect extends JQueryView {
  companyId: number;
  investeeId: number;

  constructor(companyId: number, investeeId: number) {
    super('.title-parts');
    this.companyId = companyId;
    this.investeeId = investeeId;
  }

  @on({ event: 'change', selector: '.js-change_select_investees' })
  onChangeFormControl(event: any) {
    const selected_stage = $('#stage').val();
    const selected_assessment = $('#assessment').val();
    const isAssessmentChanged = $(event.target).attr('id') === 'assessment';
    $.ajax({
      url: `/api/v1/my/vc/investees/${this.investeeId}`,
      type: 'PATCH',
      dataType: 'json',
      data: {
        company_investee: {
          stage: selected_stage,
          assessment: selected_assessment,
        },
      },
    })
      .done(() => {
        if (isAssessmentChanged) {
          $("#assessment option[value='']").remove();
        }
      })
      .fail(() => {
        alert('更新に失敗しました');
      });
    event.stopPropagation();
  }
}
